import { render, staticRenderFns } from "./AwaitingCustomer.vue?vue&type=template&id=8f12bfe4"
import script from "./AwaitingCustomer.vue?vue&type=script&lang=js"
export * from "./AwaitingCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports